<template>
  <div id="app">
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center"
      style="height: 100vh"
    >
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css"
    />
    <!-- Focus target reset on route change; its text is read by screen readers -->
    <span ref="routeAnnouncer" class="sr-only route-announcer" tabindex="-1">{{
      routeAnnouncement
    }}</span>
    <!-- Announces titles that views set only after loading data -->
    <span class="sr-only" aria-live="polite" aria-atomic="true">{{
      lateTitleAnnouncement
    }}</span>
    <a href="#main-content" class="skip-link" @click.prevent="skipToMain"
      >Skip to main content</a
    >
    <HeaderComponent />
    <main id="main-content" ref="main" class="content" tabindex="-1">
      <router-view />
    </main>

    <FooterComponent />
  </div>
</template>

<style lang="scss">
@import "@/assets/scss/variables.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}

h3 {
  font-size: 1.25rem !important;
  margin: 0;
  padding: 0;
  font-weight: bold;
}
h4 {
  font-size: 14px !important;
  display: inline;
  margin: 0;
  padding: 0;
  font-weight: bold;
}

/* Skip link: hidden off-screen until it receives keyboard focus */
.skip-link {
  position: absolute;
  left: 8px;
  top: -100px;
  z-index: 10000;
  padding: 8px 16px;
  background: #fff;
  color: #0052a3;
  font-weight: bold;
  border: 2px solid #005fcc;
  border-radius: 4px;
}
.skip-link:focus {
  top: 8px;
}
#main-content:focus,
.route-announcer:focus {
  outline: none !important;
}

/* Universal focus indicator for all focusable elements */
:focus {
  outline: 2.5px solid #005fcc !important; /* Deep blue, high contrast on white */
  outline-offset: 2px;
}

/* Override Bootstrap's default button focus to ensure it's accessible */
.btn:focus,
.btn.focus {
  outline: 2.5px solid #005fcc !important;
  outline-offset: 2px;
  box-shadow: none !important;
}

.btn-primary {
  background-color: $primary-color;
  color: $text-color;
  border-color: $primary-color;
}
.btn-primary:focus,
.btn-primary:active,
.btn-primary:active:focus {
  color: $text-color;
  background-color: $primary-color-hover;
  border-color: $primary-color-hover;
  box-shadow: 0 0 0 3px $primary-color-hover;
}

.btn-outline-primary {
  color: $primary-color;
  border-color: $primary-color;
}
.btn-outline-primary:hover,
.btn-outline-primary:focus {
  background-color: $primary-color-hover;
  border-color: $primary-color-hover;
}

.btn-secondary {
  background-color: $secondary-color;
  color: $text-color;
  border-color: $secondary-color;
}
.btn-secondary:hover {
  color: $text-color;
  background-color: $secondary-color-hover;
  border-color: $secondary-color-hover;
}
.btn-secondary:focus,
.btn-secondary:active,
.btn-secondary:active:focus {
  color: $text-color;
  background-color: $secondary-color-active;
  border-color: $secondary-color-active;
  box-shadow: 0 0 0 3px $secondary-color-hover;
}

.btn-outline-secondary {
  color: $secondary-color;
  border-color: $secondary-color;
}
.btn-outline-secondary:hover,
.btn-outline-secondary:focus {
  color: $text-color;
  background-color: $secondary-color-hover;
  border-color: $secondary-color-hover;
}

.btn-danger {
  background-color: $danger-color;
  color: $text-color;
  border-color: $danger-color;
}
.btn-danger:focus,
.btn-danger:active,
.btn-danger:active:focus {
  color: $text-color;
  background-color: $danger-color-hover;
  border-color: $danger-color-hover;
  box-shadow: 0 0 0 3px $danger-color-hover;
}

.btn-outline-danger {
  color: $danger-color;
  border-color: $danger-color;
}
.btn-outline-danger:hover,
.btn-outline-danger:focus {
  background-color: $danger-color-hover;
  border-color: $danger-color-hover;
  color: #ffffff !important;
}

.content {
  min-height: 76%;
}

.link {
  color: #2c3e50;
  text-decoration: none;
  margin: 0 15px;
}

.link:hover {
  color: #3498db;
}
.custom-navbar .b-nav-item-dropdown:hover,
.custom-navbar .b-nav-item-dropdown.menu-active {
  background-color: #f0f0f0; /* Change this color to your desired highlight color */
}

a {
  color: #0052a3;
  text-decoration: underline;
}
hr {
  margin-top: 0.2rem;
  margin-bottom: 0.5rem;
}

input[type="checkbox"]:focus,
input[type="radio"]:focus {
  outline: none;
  box-shadow: 0 0 0 1px #005fcc;
  border: 2px solid #005fcc;
}

.breadcrumb-item.active {
  color: black;
}
.page-link {
  color: #0052a3;
}
.page-item.active .page-link {
  background-color: #0052a3;
}
.highlight-term {
  color: #9500a3;
}
.highlight-text {
  color: #d30159;
}
.btn-info {
  color: black;
}
.detail-wrapper {
  height: 100%;
  font-size: 14px;

  display: flex;
  .side-wrapper {
    width: 12%;
    height: 100%;
    text-align: left;

    .side-item {
      background-color: #f5f7f5;
      @media (max-width: 480px) {
        font-size: 12px;
        padding: 5px;
        padding-right: 50px;
      }
    }

    [aria-current="true"] {
      background-color: #c3ce7e;
    }
  }
  @media (max-width: 768px) {
    .side-wrapper {
      // display: none;
      width: 10%;
    }
  }
  .list-wrapper {
    width: 88%;
    height: 75vh;
    overflow-y: scroll;
  }
  @media (max-width: 768px) {
    .list-wrapper {
      width: 100%;
    }
  }
}
.overview-wrapper {
  display: flex;
  background-color: #f1efec;
  border: 1px solid #e0e0e0;
  padding: 20px;
  .breadcrumb {
    padding: 10px 0;
    font-weight: bold;
    font-size: 18px;
  }
  .side-wrapper {
    width: 20%;
    min-width: 160px;
    border-right: 1px solid #e0e0e0;
    padding-right: 20px;

    .side-item {
      text-align: left;
      padding: 10px 10px;
      border-bottom: 1px solid #e0e0e0;
      font-weight: bold;
      font-size: 20px;
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
@media (max-width: 768px) {
  .overview-wrapper {
    padding: 0;
    .side-wrapper {
      display: none;
    }
  }
}
.searchWrapper {
  overflow-x: auto;
  height: 100%;
  width: 100%;
  background-color: white;
  padding: 5px;
  .pageTop {
    // background-color: antiquewhite;
    // margin: 20px;
    @media screen and (max-width: 300px) {
    }
    @media screen and (min-width: 900px) {
      //   height: 25%;
    }
  }
  .pageMain {
    background-color: #f1efec;
  }
}
.content-wrapper {
  width: 100%;
  padding-left: 20px;
  h2 {
    font-weight: bold;
    margin-bottom: 20px;
    text-align: left;
    color: #495057;
  }
  p {
    margin-bottom: 20px;
    text-align: left;
  }
  .items-panel {
    text-align: left;
    background-color: #f7f6f3;
    padding: 10px;
    .download-item {
      margin-bottom: 30px;
      h3 {
        color: #2a568f;
        font-weight: bold;
        font-size: 20px;

        margin-bottom: 10px;
        text-align: left;
      }
      p {
        margin-left: 20px;
        text-align: left;
      }
    }
    .news-item {
      margin-bottom: 30px;
      h3 {
        color: #2a568f;
        font-weight: bold;
        font-size: 20px;

        margin-bottom: 10px;
        text-align: left;
      }
      p {
        margin-left: 20px;
        text-align: left;
      }
      .news-header {
        color: #2a568f;
        font-weight: bold;
        font-size: 20px;

        margin-bottom: 10px;
        text-align: left;
      }
    }
  }
  .options-panel {
    background-color: #f7f6f3;
    padding: 10px;
    .search-option {
      margin-bottom: 30px;
      text-align: left;
      h3 {
        color: #2a568f;
        font-weight: bold;
        font-size: 20px;
        display: inline;

        margin-bottom: 10px;
        text-align: left;
      }
      p {
        margin-left: 20px;
        text-align: left;
      }
    }
  }
}

.pg-link {
  cursor: pointer;
  text-decoration: underline;
}
.pg-link:hover,
.pg-link:focus {
  background: #feffbb;
  outline: none;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding-left: 5px;
  }
  .footer-section.left {
    text-align: center;
  }

  .contact-line {
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  .social-links {
    justify-content: center;
  }
}

.star {
  color: #ffd700;
  font-size: 24px;
  font-style: normal;
  cursor: help;
}
.star-container {
  position: relative;
  display: inline-block;
}

/* Global pagination accessibility improvements for high zoom levels */
.b-pagination {
  min-width: fit-content;
  overflow: visible;
}

.b-pagination .page-link {
  min-width: 2.5rem;
  min-height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  padding: 0.5rem;
}

/* High zoom level support for pagination */
@media (min-resolution: 300dpi) {
  .b-pagination .page-link {
    min-width: 3rem;
    min-height: 3rem;
    font-size: 1.2rem;
    padding: 0.75rem;
  }
}

/* Ensure pagination containers don't get cut off */
.table-header,
.pagination-container {
  overflow: visible;
  min-width: 0;
}
</style>

<script>
import HeaderComponent from "@/components/common/HeaderComponent.vue";
import FooterComponent from "@/components/common/FooterComponent.vue";
import { mapGetters } from "vuex";
import Cookies from "js-cookie";

export default {
  name: "TairHome",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      searchText: null,
      lastSearchText: null,
      searchTypes: ["Gene"],
      selectedSearchType: "Gene",
      searchAlreadyShown: false,
      //   institution: null,
      subscribeStatus: "Subscribed",
      loading: true,
      routeAnnouncement: "",
      lateTitleAnnouncement: "",
    };
  },
  computed: {
    ...mapGetters("authProfile", ["getLoggedIn"]),
    ...mapGetters("subscriptionStatus", ["institution", "status"]),
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed
    clearInterval(this.cookieInterval);
    if (this.titleObserver) this.titleObserver.disconnect();
  },
  mounted() {
    this.cookieInterval = setInterval(() => {
      this.checkCookies();
    }, 5000);
    // Some views (e.g. gene/locus detail) set document.title only after
    // their data loads, well after the route announcer has read it. Watch
    // the <title> for a while after each navigation and announce late
    // changes through the live region.
    this.titleObserver = new MutationObserver(() => this.onTitleChange());
    this.titleObserver.observe(document.head, {
      subtree: true,
      childList: true,
      characterData: true,
    });
    // Load auth profile on application mount. ensureAuthProfile joins any
    // load already running (the /auth/login guard starts one), so this is
    // safe on every route; /auth/login no longer reloads the page.
    // (TAIR3-995)
    this.$store.dispatch("authProfile/ensureAuthProfile");
    this.$store.dispatch("subscriptionStatus/ensureInstitution");
    this.init();
    this.loading = false;
  },
  watch: {
    // The SPA never reloads, so focus would stay on the clicked nav link.
    // On a path change, move focus to the top of the page (like a real page
    // load) so the next Tab reaches the skip link, and announce the new page.
    // Query/hash-only changes (search filters, paging, anchors) are ignored.
    "$route.path"() {
      this.routeChangedAt = Date.now();
      this.routeAnnounced = false;
      this.lateTitleAnnouncement = "";
      // Views set document.title in mounted(), which runs after this watcher
      setTimeout(() => {
        this.routeAnnouncement = document.title;
        this.routeAnnounced = true;
        // Focus only after the span renders the new title, so screen readers
        // don't read the previous page's title
        this.$nextTick(() => {
          if (this.$refs.routeAnnouncer) {
            this.$refs.routeAnnouncer.focus({ preventScroll: true });
          }
        });
      }, 100);
    },
    getLoggedIn(newValue) {
      console.log("loggedIn changed:", newValue); // Logs whenever loggedIn changes
    },
  },
  methods: {
    ...mapGetters("authProfile", ["getLoginUrl"]),
    async init() {},
    onTitleChange() {
      // Before the first announcement the watcher's timer reads the title;
      // after the window, title changes are not tied to a navigation.
      const LATE_TITLE_WINDOW_MS = 10000;
      if (
        !this.routeAnnounced ||
        Date.now() - this.routeChangedAt > LATE_TITLE_WINDOW_MS ||
        document.title === this.routeAnnouncement
      ) {
        return;
      }
      // Keep the focused announcer accurate and read out the final title
      this.routeAnnouncement = document.title;
      this.lateTitleAnnouncement = document.title;
    },
    skipToMain() {
      // Move focus past the header nav without touching the router hash
      this.$refs.main.focus();
      this.$refs.main.scrollIntoView();
    },
    goSearch() {
      if (this.searchText && this.searchText !== "") {
        // this.lastSearchText = this.searchText;
        this.$nextTick(() => {
          if (this.$route.path !== "/results") {
            this.searchAlreadyShown = false;
          }
          this.$router.push({
            path: "/results",
            query: {
              mainType: "general",
              searchText: this.searchText,
              category: "genes",
            },
          });
          this.searchText = "";
        });
      }
    },
    async checkCookies() {
      const credentialId = Cookies.get("credentialId");
      const secretKey = Cookies.get("secretKey");

      // TAIR3-995: cookies are present but the last profile load gave up on
      // a backend hiccup, or came back partial. Refresh in the background;
      // the action paces itself and never blocks navigation.
      if (
        credentialId &&
        secretKey &&
        this.$store.getters["authProfile/didProfileLoadFail"]
      ) {
        this.$store.dispatch("authProfile/refreshAuthProfile");
        return;
      }

      // If cookies are not present, update the Vuex state to logged out
      if (!credentialId || !secretKey) {
        try {
          // Update the loggedIn state to false
          this.$store.commit("authProfile/UPDATE_STATE", { loggedIn: false });
          // Call the invalidate action to clear session-related data
          await this.$store.dispatch("authProfile/invalidate");
          // Clear the interval
          clearInterval(this.cookieInterval);
          if (this.$route.path === "/profile") {
            this.$router.push("/");
          }
        } catch (error) {
          console.error("Error while checking cookies and logging out:", error);
        }
      }
    },
  },
};
</script>
